export const servicesSuscription = [
  {
    value: 'Sin ciclo',
    label: 'Sin ciclo'
  },
  {
    value: 'Fecha',
    label: 'Fecha'
  },
  {
    value: 'Dias a la semana',
    label: 'Dias a la semana'
  },
  {
    value: 'Numero de dias',
    label: 'Numero de dias'
  },
];

export const serviceDays = [
  {
    value: 'Lunes',
    // label: 'Lunes',
    checked: false
  },
  {
    value: 'Martes',
    // label: 'Martes',
    checked: false
  },
  {
    value: 'Miercoles',
    // label: 'Miercoles',
    checked: false
  },
  {
    value: 'Jueves',
    // label: 'Jueves',
    checked: false
  },
  {
    value: 'Viernes',
    // label: 'Viernes',
    checked: false
  },
  {
    value: 'Sabado',
    // label: 'Sabado',
    checked: false
  },
  {
    value: 'Domingo',
    // label: 'Domingo',
    checked: false
  },
];

export const daysString = serviceDays.map(a => a.value).join(" ")